import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/home/icon_01.png'


const _withScopeId = n => (_pushScopeId("data-v-2137e10c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-why-body" }
const _hoisted_2 = { class: "product-content-m" }
const _hoisted_3 = { class: "content-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "why-title" }, "为什么选择我们?", -1))
const _hoisted_5 = { class: "product-details" }
const _hoisted_6 = { class: "details-left single-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "product-img",
  src: "https://sct-ieds-test.oss-cn-shenzhen.aliyuncs.com/file/20230612103507.png",
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "product-text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "details-title" }, "多样化模版", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "text-icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = { class: "details-left" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "product-img",
  src: "https://sct-ieds-test.oss-cn-shenzhen.aliyuncs.com/file/20230612103430.png",
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "product-text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "details-title" }, "可视化营销产品构建器", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "text-icon",
  src: _imports_0,
  alt: ""
}, null, -1))


import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "productWhyView",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const productList = [
  "全品类的行业营销模版",
  "助力企业高效营销",
  "支持在线编辑",
  "所见即所得",
];
const productListNext = [
  "响应式数字化平台管理",
  "灵活适应发展结构及展示需求",
  "按需修改或增删展示内容",
  "高效营销",
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productList, (i, index) => {
                return _createElementVNode("div", {
                  class: "text-item",
                  key: index
                }, [
                  _hoisted_10,
                  _createElementVNode("span", null, _toDisplayString(i), 1)
                ])
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productListNext, (i, index) => {
                return _createElementVNode("div", {
                  class: "text-item",
                  key: index
                }, [
                  _hoisted_15,
                  _createElementVNode("span", null, _toDisplayString(i), 1)
                ])
              }), 64))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})